import React from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact  from "highcharts-react-official";
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
import Exporting from "highcharts/modules/exporting";
import OfflineExporting from 'highcharts/modules/offline-exporting';
import { getMonthDateYearTimePeriod } from 'helpers/DateUtil'

Exporting(Highcharts);
OfflineExporting(Highcharts)
NoDataToDisplay(Highcharts);

class Line extends React.Component {
  render() {
    const {
      title,
      categories,
      data,
      additionalOptions
    } = this.props

    const options = {
      chart: {
        type: 'line',
        spacingBottom: 30
      },
      title: {
          text: title
      },
      xAxis: {
          categories: categories
      },
      yAxis: {
          allowDecimals: false,
          title: {
              text: ''
          }
      },
      series: data,
      credits: {
        text: `Source: Fulcrum (nvidia.com) <br /> ${getMonthDateYearTimePeriod(new Date())}`,
        href: false,
        style: {
          cursor: 'default'
        },
        position: {
          align: 'right',
          verticalAlign: 'bottom',
          y: -20
        }
      },
      lang: {
        noData: "No data available"
      },
      exporting: {
        fallbackToExportServer: false,
        buttons: {
          contextButton: {
            menuItems: ['downloadPNG','downloadJPEG']
          }
        }
      }
    };

    if (additionalOptions) {
      Object.assign(options, additionalOptions); 
    }

    return (
      <div>
        <HighchartsReact highcharts={Highcharts} options={options} />
      </div>
    );
  }
}
export default Line